import { useId } from 'react'
import type { CohortContent } from '../types'
import { CohortInstructorCard } from './CohortInstructorCard'
import { CohortSectionHeader } from './CohortSectionHeader'

export const CohortInstructors = ({
  instructors,
}: {
  instructors: CohortContent['instructors']
}) => {
  const headingId = useId()

  return (
    <section aria-labelledby={headingId} className='container py-8'>
      <CohortSectionHeader
        id={headingId}
        eyebrow={instructors.eyebrow}
        headline={instructors.headline}
      />
      <div className='mt-8 flex flex-col gap-7'>
        {instructors.items.map((instructor) => (
          <CohortInstructorCard key={instructor.id} instructor={instructor} />
        ))}
      </div>
    </section>
  )
}
